class ImageTextCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.carousel = new Splide(this.querySelector('.splide'), {
      arrows: false,
      perPage: 1,
      gap: 250
    });

    this.carousel.mount();
  }
}

customElements.define('image-text-carousel', ImageTextCarousel);
